<!--
 * @Date: 2023-06-01
 * @Description: 投票管理
-->
<template>
    <div class="box" v-loading.fullscreen.lock="state.loading" element-loading-text="操作中...">
        <div class="main-wrap">
            <div class="breadcrumb">
                <a>运营管理</a>
                <i class="iconfont icon-arrow"></i><a @click.stop="goHome">抽奖管理</a>
                <i class="iconfont icon-arrow"></i>创建抽奖
            </div>
            <div class="draw_inner">
                <h2>创建抽奖</h2>
                <div class="step">
                    <el-steps :active="3" :space="132" align-center style="width: 540px">
                        <el-step
                            v-for="(item, index) in state.steps"
                            :key="index"
                            :title="item.title"
                            :icon="item.icon"
                        />
                    </el-steps>
                </div>
                <div class="success">
                    <p>您已成功发布抽奖活动，已在详情页中展示</p>
                    <div class="example">
                        <div class="pro">
                            <img src="~@assets/img/draw/example_pro.png" />
                            <p>众筹详情入口</p>
                        </div>
                        <div class="idea">
                            <img src="~@assets/img/draw/example_idea.png" />
                            <p>创意详情入口</p>
                        </div>
                    </div>
                    <span>*以上内容均为虚构，仅用作抽奖卡片示意</span>
                </div>
                <div class="auth_bottom">
                    <el-button type="primary" @click.stop="goHome">返回抽奖管理</el-button>  
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { reactive } from 'vue'
    import { useRouter } from 'vue-router'
    const router = useRouter()
    const state = reactive({
        loading:false,
        steps: [
            {
                title: "选择项目",
                icon: 'CircleCheckFilled'
            },
            {
                title: "编辑抽奖信息",
                icon: 'CircleCheckFilled'
            },
            {
                title: "发布抽奖",
            }
        ],
    })
    const goHome = () => {
        router.push({
            name: 'drawtool_init'
        })
    }
</script>
<style lang="scss" scoped>
.box{
    // padding: 0 0 0 20px;
    .main-wrap{
        margin:0 auto;
        .breadcrumb{
            display: flex;
            align-items: center;
            font-weight: 500;
            padding: 0 0 20px 0;
            color: #1A1A1A;
            font-size: 16px;
            line-height: 16px;
            a{
                cursor: pointer;
                color: #7F7F7F;
                &:hover{
                    color: #1A1A1A;
                }
            }
            i{
                padding: 0 10px;
                color: #7F7F7F;
            }
        }
        .draw_inner{
            background: #fff;
            min-width: 840px;
            border-radius: 8px;
            padding: 20px;
            overflow: hidden;
            >h2{
                margin: 0;
                font-size: 20px;
                font-weight: 500;
                color: #1A1A1A;
                line-height: 20px;
            }
            .step{
                margin:20px 0 0 0;
                height: 91px;
                background: #F8F8F8;
                display: flex;
                align-items: center;
                justify-content: center;
                ::v-deep(.el-step__title){
                    width:180px;
                    &.is-wait,&.is-process{
                        font-weight:400;
                    }
                    &.is-finish{
                        font-weight:600;
                    }
                }
                ::v-deep(.el-step__head){
                    &.is-finish{
                        height:24px;
                        .el-step__icon.is-icon{
                            background:#F8F8F8;
                        }
                    }
                }
            }
            .success{
                >p{
                    font-size: 16px;
                    padding: 20px 0;
                    font-weight: 400;
                    color: #1A1A1A;
                    line-height: 16px;
                }
                >span{
                    display: inline-block;
                    padding: 10px 0 20px 0;
                    font-size: 14px;
                    font-weight: 400;
                    color: #7F7F7F;
                    line-height: 14px;
                }
                .example{
                    width: 522px;
                    height: 564px;
                    padding: 20px;
                    background: #F8F8F8;
                    display:flex;
                    align-items:center;
                    justify-content: space-between;
                    >div{
                        width:231px;
                        img{
                            width: 100%;
                        }
                        p{
                            font-size: 14px;
                            padding-top: 10px;
                            font-weight: 400;
                            color: #7F7F7F;
                            line-height: 14px;
                            text-align: center;
                        }
                    }
                }
            }
            .auth_bottom{
                width: 100%;
                height: 64px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 12px 0 0 0;
                background: #FFFFFF;
                box-shadow: 0px -1px 0px 0px #E8E8E8;
            }
        }
    }
}
</style>